<template>
  <div class="MaterialPrice">
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        title="价格维护"
        width="1000px"
        @close="$reset('form')">
      <el-form
          ref="form"
          :model="materialPrice"
          :rules="ruleValidate"
          class="form"
          label-width="90px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="物料编号">
              <el-input v-model="materialPrice.materialNO" disabled/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="物料名称">
              <el-input v-model="materialPrice.materialName" disabled/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="标准价">
              <el-input v-model="materialPrice.standardPrice" type="number" min="0"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="标准价浮价">
              <el-input v-model="materialPrice.standardFloatingPrice" type="number" min="0"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="成本价">
              <el-input v-model="materialPrice.costPrice" type="number" min="0"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="成本价浮价">
              <el-input v-model="materialPrice.costFloatingPrice" type="number" min="0"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="第一梯价">
              <el-input v-model="materialPrice.level1Price" type="number" min="0"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="第一梯浮价">
              <el-input v-model="materialPrice.level1FloatingPrice" type="number" min="0"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="第二梯价">
              <el-input v-model="materialPrice.level2Price" type="number" min="0"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="第二梯浮价">
              <el-input v-model="materialPrice.level2FloatingPrice" type="number" min="0"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="第三梯价">
              <el-input v-model="materialPrice.level3Price" type="number" min="0"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="第三梯浮价">
              <el-input v-model="materialPrice.level3FloatingPrice" type="number" min="0"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: "MaterialPrice",
    components: {},
    data() {
      return {
        dialogVisible: false,
        submitLoading: false,
        materialPrice: {
          materialId: "",
          materialNO: "",
          materialName: "",
          standardPrice: "",
          standardFloatingPrice: "",
          costPrice: "",
          costFloatingPrice: "",
          level1Price: "",
          level1FloatingPrice: "",
          level2Price: "",
          level2FloatingPrice: "",
          level3Price: "",
          level3FloatingPrice: "",
        },
        ruleValidate: {},
      };
    },
    methods: {
      open(id) {
        this.materialPrice.materialId = id;
        this.dialogVisible = true;
        if (id > 0) {
          this.getData();
        }
      },

      // 根据物料id查询价格信息
      getData() {
        this.$http.get("basic", `materialPrice/${this.materialPrice.materialId}`).then((resp) => {
          if (resp.success) {
            this.materialPrice = resp.data;
          }
        });
      },

      handleSubmit() {
        if (this.materialPrice.standardPrice < 0) {
          this.$confirm("标准价不可小于0", "错误", {
            type: "error",
            showCancelButton: false,
          });
          return;
        }
        if (this.materialPrice.standardFloatingPrice < 0) {
          this.$confirm("标准价浮价不可小于0", "错误", {
            type: "error",
            showCancelButton: false,
          });
          return;
        }
        if (this.materialPrice.costPrice < 0) {
          this.$confirm("成本价不可小于0", "错误", {
            type: "error",
            showCancelButton: false,
          });
          return;
        }
        if (this.materialPrice.costFloatingPrice < 0) {
          this.$confirm("成本价浮价不可小于0", "错误", {
            type: "error",
            showCancelButton: false,
          });
          return;
        }
        if (this.materialPrice.level1Price < 0) {
          this.$confirm("第一梯价不可小于0", "错误", {
            type: "error",
            showCancelButton: false,
          });
          return;
        }
        if (this.materialPrice.level1FloatingPrice < 0) {
          this.$confirm("第一梯浮价不可小于0", "错误", {
            type: "error",
            showCancelButton: false,
          });
          return;
        }
        if (this.materialPrice.level2Price < 0) {
          this.$confirm("第二梯价不可小于0", "错误", {
            type: "error",
            showCancelButton: false,
          });
          return;
        }
        if (this.materialPrice.level2FloatingPrice < 0) {
          this.$confirm("第二梯浮价不可小于0", "错误", {
            type: "error",
            showCancelButton: false,
          });
          return;
        }
        if (this.materialPrice.level3Price < 0) {
          this.$confirm("第三梯价不可小于0", "错误", {
            type: "error",
            showCancelButton: false,
          });
          return;
        }
        if (this.materialPrice.level3FloatingPrice < 0) {
          this.$confirm("第三梯浮价不可小于0", "错误", {
            type: "error",
            showCancelButton: false,
          });
          return;
        }
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .put("basic", "materialPrice", this.materialPrice)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("编辑成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>
